import { getSearchAppsApi_v4 } from '@/apis/apps'
import { searchResultsTransformer } from './index'

export const getSearchResultTransformer = async ({ queryKey }) => {
  const result = await getSearchAppsApi_v4(queryKey[1], queryKey[2])
  return searchResultsTransformer(result)
}
